import React from "react";
import { useDarkMode } from "../../contexts/DarkModeContext";
import "./Footer.css";

const Footer = () => {
  const { isDarkMode } = useDarkMode();

  return (
    <footer
      style={{
        borderTop: isDarkMode ? "1px solid #404040" : "1px solid #e5e5e5",
        backgroundColor: isDarkMode ? "#1f1f1f" : "#fff",
        padding: "3rem clamp(1rem, 4vw, 2rem)",
        marginTop: "4rem",
        boxSizing: "border-box",
        width: "100%",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "3rem",
          boxSizing: "border-box",
          width: "100%",
        }}
      >
        <div>
          <div
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: isDarkMode ? "#e5e5e5" : "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Collavo
          </div>
          <p
            style={{
              fontSize: "14px",
              color: isDarkMode ? "#a3a3a3" : "#737373",
              lineHeight: "1.6",
              margin: 0,
            }}
          >
            Collavo is a platform that enables meaningful collaboration
            between you and the church.
          </p>
        </div>

        <div>
          <h4
            style={{
              fontSize: "14px",
              fontWeight: "600",
              color: isDarkMode ? "#e5e5e5" : "#1a1a1a",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              marginBottom: "1rem",
            }}
          >
            Company
          </h4>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
            }}
          >
            {[
              { label: "About", href: "/about" },
              { label: "Contact", href: "/contact" },
              { label: "Privacy", href: "/privacy" },
              { label: "Terms", href: "/terms" },
            ].map((item, index) => (
              <li key={index} style={{ marginBottom: "0.5rem" }}>
                <a
                  href={item.href}
                  style={{
                    fontSize: "14px",
                    color: isDarkMode ? "#a3a3a3" : "#737373",
                    textDecoration: "none",
                    transition: "color 0.2s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.color = isDarkMode ? "#e5e5e5" : "#1a1a1a")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.color = isDarkMode ? "#a3a3a3" : "#737373")
                  }
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div
        style={{
          maxWidth: "1200px",
          margin: "3rem auto 0 auto",
          paddingTop: "2rem",
          borderTop: isDarkMode ? "1px solid #404040" : "1px solid #e5e5e5",
          textAlign: "center",
          fontSize: "14px",
          color: isDarkMode ? "#a3a3a3" : "#737373",
        }}
      >
        © {new Date().getFullYear()} Collavo. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
